import React, { useState, useEffect } from 'react';
import { SearchIcon as UiSearchIcon, AlertIcon, ArrowLeftIcon } from '../ui/icons';
import styled, { createGlobalStyle, css, keyframes } from 'styled-components';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from '../translations';
import { API_BASE } from '../config';
// Daty wysyłane do API jako LOKALNY dzień: toISOString() na lokalnej północy daje w Polsce
// poprzedni dzień (UTC), więc zakresy dostępności i blokady przesuwały się o jeden dzień wstecz.
import { formatYMD } from '../utils/contract';
import {
  monthGridWindow, daysWindow, mergeWindows, windowsKey, mergeReservationLists, reservationListQuery,
} from '../utils/reservationWindow';
import InventoryModal from '../components/InventoryModal';
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import DatePicker from 'react-datepicker';
import { shift } from '@floating-ui/react';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import { pl } from 'date-fns/locale';
import { slideIn, IconButton, IconBadge } from '../ui/common';
import { localeTag } from '../utils/format';
import { reservationColor } from '../utils/reservationColors';
import useZasadyWynajmu from '../utils/useZasadyWynajmu';
import {
  agenda, assignLanes, buildEntries, daysBetweenInclusive, entriesOnDay, entryKey, itemStatus, monthOccupancy, ribbonPiece,
} from '../utils/equipmentSchedule';

// Kalendarzyk dat dosuwany do krawędzi ekranu. Na dotyku dni mają 44 px, więc kalendarzyk jest
// szerszy (index.css), a react-datepicker 8 sam go tylko odwraca (flip), nie przesuwa: na telefonie
// 390 px strzałka następnego miesiąca i niedziela chowały się za krawędzią (przegląd gałęzi, 28.09.2026).
const DOSUN_DO_EKRANU = [shift({ padding: 8 })];
registerLocale('pl', pl);

// SVG Icons
const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PackageIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 9.4L7.5 4.21l-1.5.87v9.84l9-5.13v-1.39z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2"/>
    <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline points="3,6 5,6 21,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const UserIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const MailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PhoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MapPinIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 10c0 5-9 12-9 12S3 15 3 10a9 9 0 1 1 18 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const TagIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.59 13.41 13.41 20.6a2 2 0 0 1-2.82 0L3 13V3h10l7.59 7.59a2 2 0 0 1 0 2.82Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.5 7.5h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CreditCardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="4" width="20" height="16" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
    <line x1="2" y1="9" x2="22" y2="9" stroke="currentColor" strokeWidth="2"/>
    <line x1="7" y1="15" x2="9" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="11" y1="15" x2="17" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const FileTextIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="9" y1="13" x2="15" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="9" y1="17" x2="15" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// DODANE: Ikony brakujące w EquipmentCalendar (CheckIcon, XIcon)
const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline points="4,12 10,18 20,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const XIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const ChevronUpIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 15l-6-6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Container = styled.div`
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  padding: clamp(12px, 2vw, 24px);
  color: var(--text);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  
  /* Style głównej karty (Main Card) */
  background: var(--card-bg);
  border-radius: 24px;
  box-shadow: var(--shadow-lg);
  position: relative;
  overflow: hidden;
  border: 1px solid var(--input-border);
  min-height: calc(100vh - 48px);
  /* Reszta panelu (PanelContainer, ui/common.js) dostaje przy wejsciu na strone
     delikatny fade+wjazd z dolu. Ta strona miala WLASNY Container bez tej animacji. */
  animation: ${slideIn} 0.6s ease-out;

  /* Pasek gradientowy - ujednolicony z magazynem (wielokolorowy) */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: var(--border);
    z-index: 10;
  }

  @media (min-width: 1400px) {
    max-width: 1600px;
    padding: 32px;
  }

  @media (max-width: 1024px) {
    padding: 20px;
    border-radius: 20px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    border-radius: 16px;
    min-height: auto;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  /* Usunięto style karty, aby nagłówek był częścią głównego kontenera */
  padding: 0;
  background: transparent;
  border: none;
  
  @media(max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

// Ikona hero strony — wspólna plakietka z ui/common.js (IconBadge); ton "pine" (świerk)
// sygnalizuje temat strony (sprzęt), patrz komentarz przy ICON_TONES w ui/common.js.
const TitleIcon = styled(IconBadge).attrs({ $size: 48, $tone: 'pine' })``;

const Title = styled.h1`
  margin: 0;
  font-size: 2rem;
  font-weight: 800;
  color: var(--text);
  
  @media(max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const BackButton = styled.button`
  background: var(--primary);
  color: var(--primary-contrast);
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    filter: brightness(0.92);
    transform: translateY(-2px);
    box-shadow: var(--shadow-primary);
  }
`;

// ── Układ strony (przebudowa czytelności, 2026-10-02) ───────────────────────────────────────
// Strona odpowiada na jedno pytanie: „czy ta sztuka jest wolna i kto ją ma kiedy?". Dlatego:
// pasek sztuki ze zdaniem o jej stanie na górze, siatka z podpisanymi wstęgami rezerwacji
// i jedna agenda z prawej (wybrany dzień + najbliższe 30 dni) zamiast trzech osobnych kart.

// Przełączanie sztuki: w trakcie ładowania stara zawartość przygasa (i nie przyjmuje kliknięć),
// nowa wchodzi krótkim przenikaniem z lekkim podjazdem. Bez animacji przy „ogranicz ruch".
const wejscieWidoku = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: none; }
`;

const przejscieWidoku = css`
  opacity: ${p => (p.$busy ? 0.45 : 1)};
  pointer-events: ${p => (p.$busy ? 'none' : 'auto')};
  transition: opacity 0.18s ease;
  animation: ${wejscieWidoku} 0.28s ease-out;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    transition: none;
  }
`;

const MainContent = styled.div`
  ${przejscieWidoku}
  display: grid;
  gap: 20px;
  align-items: start;

  @media (min-width: 1200px) {
    grid-template-columns: minmax(0, 2fr) minmax(300px, 1fr);
  }
`;

const ItemBar = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px 28px;
  align-items: center;
  margin-bottom: 20px;
  padding: 14px 20px;
  border: 1px solid var(--input-border);
  border-radius: 16px;
  background: var(--card-bg);

  @media (min-width: 900px) {
    grid-template-columns: minmax(260px, 0.9fr) minmax(0, 1.4fr);
  }
`;

const EquipmentSelector = styled.div`
  position: relative;
  z-index: 10;
  min-width: 0;
`;

const SelectorButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  margin: -8px -10px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 12px;
  color: var(--text);
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover { background: var(--table-row-hover); }
  &:focus-visible { outline: 2px solid var(--primary); outline-offset: 2px; }
  svg { flex-shrink: 0; color: var(--text-muted); }
`;

const SelectorLabel = styled.span`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const SelectorTitle = styled.span`
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
`;

const SelectorValue = styled.span`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 10px;
  font-size: 1.2rem;
  font-weight: 800;
  line-height: 1.25;
  color: var(--text);
`;

const SelectorNumber = styled.span`
  font-size: 0.8rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--text-muted);
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 12px);
  left: -10px;
  right: -10px;
  background: var(--card-bg);
  border: 1px solid var(--input-border);
  border-radius: 12px;
  box-shadow: var(--shadow-md);
  padding: 8px;
  display: ${props => props.isOpen ? 'block' : 'none'};
  max-height: 320px;
  overflow-y: auto;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--input-border);
  border-radius: 8px;
  background: var(--input-bg);
  color: var(--text);
  margin-bottom: 8px;
  font-size: 0.9rem;

  &:focus { outline: none; border-color: var(--primary); }
`;

const DropdownItem = styled.div`
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  background: ${props => props.isActive ? 'var(--primary-light)' : 'transparent'};
  border: 1px solid ${props => props.isActive ? 'var(--primary)' : 'transparent'};

  &:hover { background: var(--table-row-hover); }
`;

const ItemName = styled.div`
  font-weight: 600;
  color: var(--text);
  font-size: 0.9rem;
`;

const ItemDetails = styled.div`
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-top: 2px;
`;

// Zdanie o stanie sztuki — pierwsza rzecz, którą czyta obsługa.
const StatusBlock = styled.div`
  ${przejscieWidoku}
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;

  @media (min-width: 900px) {
    padding-left: 28px;
    border-left: 1px solid var(--border);
  }
`;

const StatusLine = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text);
`;

const STATUS_TONE = {
  rented: 'var(--danger)',
  held: 'var(--primary)',
  free: 'var(--success)',
  neutral: 'var(--text-muted)',
};

const StatusDot = styled.span`
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${p => STATUS_TONE[p.$tone] || STATUS_TONE.neutral};
  box-shadow: 0 0 0 4px color-mix(in srgb, ${p => STATUS_TONE[p.$tone] || STATUS_TONE.neutral} 18%, transparent);
`;

const StatusSub = styled.p`
  margin: 0 0 0 20px;
  font-size: 0.875rem;
  color: var(--text-muted);
`;

const Occupancy = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 12px;
  margin: 4px 0 0 20px;
  font-size: 0.8rem;
  color: var(--text-muted);

  > span:first-child::first-letter { text-transform: uppercase; }
`;

const OccupancyTrack = styled.span`
  flex: 0 0 120px;
  height: 6px;
  border-radius: 3px;
  background: var(--border);
  overflow: hidden;

  > span {
    display: block;
    height: 100%;
    border-radius: 3px;
    background: var(--text-muted);
  }
`;

// ── Siatka miesiąca ────────────────────────────────────────────────────────────────────────
// Komórki bez odstępów, oddzielone liniami siatki: dzięki temu wstęga rezerwacji biegnie przez
// kolejne dni jednym kawałkiem, a nie jako szereg osobnych kresek (dawny wygląd nie mówił, gdzie
// kończy się jedna rezerwacja i zaczyna następna ani czyja jest).
const TILE_HEIGHT = 96;
const RIBBON_TOP = 36;
const RIBBON_HEIGHT = 20;
const RIBBON_GAP = 4;

const CalendarCard = styled.section`
  min-width: 0;
  padding: 14px 16px 12px;
  border: 1px solid var(--input-border);
  border-radius: 16px;
  background: var(--card-bg);

  .react-calendar {
    width: 100%;
    max-width: none;
    background: transparent;
    border: none;
    font-family: inherit;
    color: var(--text);
  }

  .react-calendar__navigation {
    display: flex;
    align-items: center;
    gap: 4px;
    height: auto;
    margin: 0 0 12px;
  }

  .react-calendar__navigation button {
    min-width: 36px;
    height: 36px;
    border: 1px solid transparent;
    border-radius: 8px;
    background: transparent;
    color: var(--text);
    font: inherit;
    font-weight: 600;
  }

  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background: var(--table-row-hover);
  }

  .react-calendar__navigation button:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 1px;
  }

  .react-calendar__navigation__label {
    font-size: 1.05rem;
    font-weight: 800;
  }

  .react-calendar__navigation__label__labelText::first-letter { text-transform: uppercase; }

  .react-calendar__month-view__weekdays {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--text-muted);
  }

  .react-calendar__month-view__weekdays__weekday {
    padding: 6px 10px;
    text-align: left;
  }

  .react-calendar__month-view__weekdays__weekday abbr {
    text-decoration: none;
    cursor: default;
  }

  .react-calendar__month-view__days {
    border-top: 1px solid var(--border);
    border-left: 1px solid var(--border);
  }

  .react-calendar__tile {
    position: relative;
    padding: 6px;
    border: none;
    border-radius: 0;
    background: var(--card-bg);
    color: var(--text);
    font: inherit;
    /* react-calendar wpisuje każdemu dniu overflow: hidden w atrybut style, więc bez
       !important nazwisko na wstędze urywało się na granicy pierwszej komórki. */
    overflow: visible !important;
  }

  .react-calendar__month-view__days__day {
    height: ${TILE_HEIGHT}px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    border-right: 1px solid var(--border);
    border-bottom: 1px solid var(--border);
  }

  /* Numer dnia: mały, w lewym górnym rogu — miejsce w komórce należy do wstęg. */
  .react-calendar__month-view__days__day abbr {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 26px;
    height: 26px;
    padding: 0 4px;
    border-radius: 13px;
    font-size: 0.8rem;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
  }

  .react-calendar__month-view__days__day--weekend abbr { color: var(--danger); }

  .react-calendar__month-view__days__day--neighboringMonth {
    background: color-mix(in srgb, var(--border) 22%, var(--card-bg));
  }

  .react-calendar__month-view__days__day--neighboringMonth abbr,
  .react-calendar__tile.is-past abbr {
    color: var(--text-muted);
    font-weight: 500;
  }

  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background: var(--table-row-hover);
  }

  .react-calendar__tile:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: -2px;
  }

  /* Wybrany dzień: obwódka i lekki odcień, NIE pełne wypełnienie — inaczej zasłaniałby wstęgi. */
  .react-calendar__month-view__days__day.react-calendar__tile--active,
  .react-calendar__month-view__days__day.react-calendar__tile--active:enabled:hover,
  .react-calendar__month-view__days__day.react-calendar__tile--active:enabled:focus {
    background: color-mix(in srgb, var(--primary) 9%, var(--card-bg));
    color: var(--text);
    box-shadow: inset 0 0 0 2px var(--primary);
  }

  /* Dziś: numer w pełnym kółku — TYLKO w siatce dni. W widoku roku ta sama reguła malowała
     niebieski prostokąt pod nazwą bieżącego miesiąca, a obwódka „wybranego dnia" dokładała
     ramkę, co razem wyglądało jak zaznaczony tekst. */
  .react-calendar__tile--now { background: var(--card-bg); }
  .react-calendar__month-view__days__day.react-calendar__tile--now abbr {
    background: var(--primary);
    color: var(--primary-contrast);
    font-weight: 700;
  }

  /* Widoki roku, dekady i stulecia: spokojne kafelki, bez linii siatki dni. Miesiąc z wybranym
     dniem ma odcień i kolor akcentu, bieżący (gdy nie jest wybrany) — tylko kolor akcentu. */
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 18px 6px;
    border-radius: 10px;
    font-weight: 600;
    text-transform: capitalize;
  }

  .react-calendar__year-view .react-calendar__tile--now,
  .react-calendar__decade-view .react-calendar__tile--now,
  .react-calendar__century-view .react-calendar__tile--now {
    color: var(--primary);
  }

  .react-calendar__year-view .react-calendar__tile--hasActive,
  .react-calendar__decade-view .react-calendar__tile--hasActive,
  .react-calendar__century-view .react-calendar__tile--hasActive,
  .react-calendar__year-view .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__year-view .react-calendar__tile--hasActive:enabled:focus {
    background: color-mix(in srgb, var(--primary) 12%, var(--card-bg));
    color: var(--primary);
    font-weight: 700;
    box-shadow: none;
  }

  @media (max-width: 640px) {
    padding: 10px 8px;
    .react-calendar__month-view__days__day { height: 76px; padding: 4px; }
    .react-calendar__month-view__weekdays__weekday { padding: 4px; text-align: center; }
  }
`;

// Kawałek wstęgi w jednej komórce. Wstęga rezerwacji ma kolor rezerwacji (ten sam co w
// kalendarzu rezerwacji, utils/reservationColors.js), oferta jest kreskowana: to wstępna
// blokada sprzętu z wysłanej oferty, a nie wypożyczenie.
const Ribbon = styled.span`
  position: absolute;
  top: ${p => RIBBON_TOP + p.$lane * (RIBBON_HEIGHT + RIBBON_GAP)}px;
  left: ${p => (p.$roundLeft ? '6px' : '0')};
  right: ${p => (p.$roundRight ? '6px' : '-1px')};
  height: ${RIBBON_HEIGHT}px;
  /* BEZ z-index i BEZ opacity: oba tworzą osobny kontekst nakładania, a wtedy etykieta
     (RibbonLabel) nie wychodzi ponad kawałki wstęgi następnych dni i nazwisko urywa się
     na granicy komórki. Przeszłość wyciszamy mieszaniem koloru, nie przezroczystością. */
  pointer-events: none;
  border-radius: ${p => `${p.$roundLeft ? 6 : 0}px ${p.$roundRight ? 6 : 0}px ${p.$roundRight ? 6 : 0}px ${p.$roundLeft ? 6 : 0}px`};
  ${p => (p.$offer
    ? `
      background: repeating-linear-gradient(135deg,
        color-mix(in srgb, var(--primary) ${p.$past ? 13 : 26}%, var(--card-bg)) 0 5px,
        color-mix(in srgb, var(--primary) ${p.$past ? 5 : 9}%, var(--card-bg)) 5px 10px);
      border: 1px dashed var(--primary);
      border-left-width: ${p.$roundLeft ? '1px' : '0'};
      border-right-width: ${p.$roundRight ? '1px' : '0'};
    `
    : `background: ${p.$past ? `color-mix(in srgb, ${p.$color} 35%, var(--card-bg))` : p.$color};`)}

  @media (max-width: 640px) {
    top: ${p => 30 + p.$lane * 14}px;
    height: 10px;
  }
`;

// Nazwisko na wstędze. Może być szersze niż jedna komórka (do końca wstęgi albo tygodnia),
// żeby nie urywało się po kilku literach; z-index ponad kawałkami wstęgi następnych dni.
const RibbonLabel = styled.span`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 7px;
  z-index: 2;
  width: calc(${p => p.$span} * 100% - 14px);
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
  color: ${p => (p.$offer ? 'var(--primary)' : p.$past ? 'var(--text)' : '#fff')};
  /* napis na kreskowanym tle oferty: otoczka w kolorze karty, inaczej paski przecinają litery */
  ${p => p.$offer && 'text-shadow: 0 0 2px var(--card-bg), 0 0 3px var(--card-bg), 0 0 4px var(--card-bg);'}

  @media (max-width: 640px) { display: none; }
`;

const MoreBadge = styled.span`
  position: absolute;
  right: 6px;
  bottom: 4px;
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--text-muted);
`;

// Widok wszystkich sztuk: wstęgi wielu sztuk naraz byłyby nieczytelne, więc liczniki.
const DayCounts = styled.span`
  position: absolute;
  left: 6px;
  right: 6px;
  bottom: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const DayCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  font-size: 0.72rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  ${p => (p.$kind === 'offer'
    ? 'color: var(--primary); border: 1px dashed var(--primary); background: color-mix(in srgb, var(--primary) 10%, transparent);'
    : 'color: var(--primary-contrast); background: var(--danger);')}
`;

const CalendarFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px 16px;
  margin-top: 12px;
`;

const Legend = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 0.8rem;
  color: var(--text-muted);
`;

const LegendItem = styled.li`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const LegendSwatch = styled.span`
  flex-shrink: 0;
  ${p => p.$kind === 'today' && `
    width: 18px; height: 18px; border-radius: 50%; background: var(--primary);
  `}
  ${p => p.$kind === 'reservation' && `
    width: 26px; height: 10px; border-radius: 4px;
    background: linear-gradient(90deg, #2563eb 0 50%, #059669 50% 100%);
  `}
  ${p => p.$kind === 'offer' && `
    width: 26px; height: 10px; border-radius: 4px; border: 1px dashed var(--primary);
    background: repeating-linear-gradient(135deg,
      color-mix(in srgb, var(--primary) 26%, transparent) 0 4px,
      color-mix(in srgb, var(--primary) 9%, transparent) 4px 8px);
  `}
`;

const TodayButton = styled.button`
  padding: 8px 14px;
  border: 1px solid var(--input-border);
  border-radius: 10px;
  background: var(--card-bg);
  color: var(--text);
  font: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: var(--table-row-hover); }
  &:focus-visible { outline: 2px solid var(--primary); outline-offset: 2px; }
`;

// ── Agenda ─────────────────────────────────────────────────────────────────────────────────
const Agenda = styled.aside`
  min-width: 0;
  border: 1px solid var(--input-border);
  border-radius: 16px;
  background: var(--card-bg);

  @media (min-width: 1200px) {
    position: sticky;
    top: 16px;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
  }
`;

const AgendaSection = styled.section`
  padding: 16px 18px;

  & + & { border-top: 1px solid var(--border); }
`;

const AgendaEyebrow = styled.h2`
  margin: 0 0 4px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
`;

const AgendaHeading = styled.p`
  margin: 0 0 12px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text);

  &::first-letter { text-transform: uppercase; }
`;

const AgendaList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const AgendaItem = styled.li`
  display: grid;
  grid-template-columns: 4px minmax(0, 1fr) auto;
  align-items: center;
  gap: 0 12px;
  border-radius: 10px;
  background: var(--input-bg);
  overflow: hidden;
`;

const AgendaStripe = styled.span`
  align-self: stretch;
  ${p => (p.$offer
    ? `background: repeating-linear-gradient(180deg, var(--primary) 0 4px, transparent 4px 7px);`
    : `background: ${p.$color};`)}
`;

const AgendaMain = styled.button`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  padding: 10px 0;
  border: none;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:focus-visible { outline: 2px solid var(--primary); outline-offset: 2px; border-radius: 6px; }
`;

const AgendaDates = styled.span`
  font-size: 0.85rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--text);

  > span { font-weight: 500; color: var(--text-muted); }
`;

const AgendaName = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.9rem;
  color: var(--text);
`;

const AgendaMeta = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.75rem;
  color: var(--text-muted);
`;

const OpenButton = styled.button`
  margin-right: 10px;
  padding: 6px 12px;
  border: 1px solid var(--input-border);
  border-radius: 8px;
  background: var(--card-bg);
  color: var(--primary);
  font: inherit;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;

  &:hover { border-color: var(--primary); }
  &:focus-visible { outline: 2px solid var(--primary); outline-offset: 2px; }
`;

const AgendaEmpty = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-muted);
`;

// DODANE: pomocnicze funkcje i stylowane przyciski/modal
const MS_PER_DAY = 24 * 60 * 60 * 1000;
const startOfDaySafe = (d) => {
  if (!d) return null;
  const x = d instanceof Date ? d : new Date(d);
  return new Date(x.getFullYear(), x.getMonth(), x.getDate());
};
const daysInclusive = (from, to) => {
  const s = startOfDaySafe(from);
  const e = startOfDaySafe(to);
  if (!s || !e) return 0;
  const diff = Math.round((e - s) / MS_PER_DAY);
  return diff >= 0 ? diff + 1 : 0;
};
const getEquipmentDailyRate = (equipment, isLongTerm) => {
  if (!equipment) return 0;
  const base = Number(equipment.price_per_day ?? equipment.price ?? 0) || 0;
  const long = Number(equipment.price_over_7 ?? equipment.long_term_price ?? 0) || 0;
  return isLongTerm && long > 0 ? long : base;
};

const ActionButtons = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
`;
const PrimaryButton = styled.button`
  background: var(--primary);
  color: var(--primary-contrast);
  border: none;
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  gap: 8px;
  align-items: center;
  box-shadow: var(--shadow-primary);
  &:hover { transform: translateY(-1px); box-shadow: var(--shadow-md); }
  &:disabled { opacity: .6; cursor: not-allowed; transform: none; }
`;
const SecondaryButtonGhost = styled.button`
  background: transparent;
  color: var(--text);
  border: 1px solid var(--input-border);
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  gap: 8px;
  align-items: center;
  &:hover { border-color: var(--primary); color: var(--primary); }
`;

// Modal (spójny z resztą)
const ModalOverlay = styled.div`
  position: fixed; inset: 0; background: rgba(15, 23, 42, 0.55);
  display: flex; align-items: center; justify-content: center;
  z-index: var(--z-overlay); padding: 20px;
`;
const ModalContent = styled.div`
  background: var(--card-bg);
  border-radius: 16px;
  padding: 24px;
  max-width: 960px;
  width: min(960px, 96vw);
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  border: 1px solid var(--input-border);
  box-shadow: 0 20px 60px var(--shadow-color);
`;
const ModalHeader = styled.div`
  display: flex; justify-content: space-between; align-items: center;
  gap: 12px; padding-bottom: 12px; border-bottom: 1px solid var(--input-border);
`;
const ModalTitle = styled.h2`
  margin: 0; font-size: 1.3rem; font-weight: 700; color: var(--text);
  display: flex; align-items: center; gap: 10px;
`;
const CloseButton = styled.button`
  background: none; border: none; color: var(--text-muted);
  font-size: 1.4rem; cursor: pointer; padding: 4px 8px;
  &:hover { color: var(--danger); }
`;
const FormGrid = styled.div`
  display: grid; gap: 16px; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
`;
const Field = styled.div`display:flex; flex-direction:column; gap:6px;`;
const Label = styled.label`font-weight:600; color: var(--text); font-size:0.9rem; display:flex; gap:6px; align-items:center;`;
const Input = styled.input`
  padding: 10px 12px; border: 2px solid var(--input-border); border-radius: 10px;
  background: var(--input-bg); color: var(--text); font-weight: 500;
  &:focus { outline:none; border-color: var(--primary); box-shadow: var(--focus-ring); }
`;
const Textarea = styled.textarea`
  padding: 10px 12px; border: 2px solid var(--input-border); border-radius: 10px;
  background: var(--input-bg); color: var(--text); font-weight: 500;
  resize: vertical; min-height: 80px;
  &:focus { outline:none; border-color: var(--primary); box-shadow: var(--focus-ring); }
`;
const ErrorText = styled.div`color:var(--danger); font-size:0.85rem;`;

const FormModal = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-overlay);
  backdrop-filter: blur(8px);
  overflow-y: auto;
  padding: 20px;
`;

const FormContainer = styled.div`
  background: var(--card-bg);
  border-radius: 20px;
  padding: 32px;
  max-width: 1000px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 75px var(--shadow-color);
  border: 1px solid var(--input-border);
  position: relative;
  
  @media(max-width: 768px) {
    padding: 20px;
  }
`;

const FormHeader = styled.div`
  margin-bottom: 32px;
  padding-bottom: 20px;
  border-bottom: 2px solid var(--input-border);
`;

const FormTitle = styled.h2`
  margin: 0 0 8px 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 12px;
  
  @media(max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const FormSubtitle = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: var(--text-muted);
`;

const FormPanel = styled.div`
  background: var(--panel-bg);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid var(--input-border);
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const FormPanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--input-border);
`;

// Wspólna plakietka ikony z ui/common.js (IconBadge) — wołający przekazuje `$tone="steel"` itp.
// zamiast `bg="var(--primary)"`, patrz komentarz przy ICON_TONES w ui/common.js.
const FormPanelIcon = IconBadge;

const FormPanelTitle = styled.h3`
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text);
`;

const FormInputGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;

  & > div {
    min-width: 0;
  }

  & label {
    margin-bottom: 20px;
  }

  @media(max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  align-items: start;

  & > div { min-width: 0; }

  @media(max-width: 920px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media(max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const FormInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

const FormLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text);
`;

const FormInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid var(--input-border);
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 500;
  background: var(--input-bg);
  color: var(--text);
  box-sizing: border-box;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: var(--focus-ring);
  }
  
  &:disabled {
    background: var(--table-row-hover);
    color: var(--text-muted);
    cursor: not-allowed;
  }
  
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    display: none;
  }
  
  &[type='number'] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
`;

const FormTextarea = styled.textarea`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid var(--input-border);
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 500;
  background: var(--input-bg);
  color: var(--text);
  box-sizing: border-box;
  transition: all 0.2s ease;
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
  
  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: var(--focus-ring);
  }
`;

const DiscountControl = styled.div`
  display: flex;
  align-items: stretch;
  border: 2px solid var(--input-border);
  border-radius: 12px;
  background: var(--input-bg);
  overflow: hidden;
  height: 44px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;
  transition: all 0.2s ease;

  &:focus-within {
    border-color: var(--primary);
    box-shadow: var(--focus-ring);
  }

  input {
    flex: 1;
    border: none;
    background: transparent;
    padding: 0 12px;
    font-size: 1rem;
    font-weight: 500;
    text-align: right;
    color: var(--text);
    height: 100%;
    box-sizing: border-box;
    outline: none;
    min-width: 0;
    
    &::placeholder {
      color: var(--text-muted);
      font-weight: 400;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    &[type='number'] {
      -moz-appearance: textfield;
    }
  }

  select {
    width: 60px;
    padding: 0 4px;
    border: none;
    border-left: 1px solid var(--input-border);
    background: transparent;
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--text);
    cursor: pointer;
    height: 44px;
    box-sizing: border-box;
    outline: none;
  }
`;

const FormEquipmentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const EquipmentItemRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  margin-bottom: 8px;
  background: var(--card-bg);
  border-radius: 8px;
  border: 1px solid var(--input-border);
  
  &:last-child { margin-bottom: 0; }
`;

const EquipmentInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

const EquipmentNameText = styled.span`
  font-weight: 500;
  color: var(--text);
`;

const EquipmentMeta = styled.span`
  font-size: 0.85rem;
  color: var(--text-muted);
`;

const EquipmentPrice = styled.span`
  font-weight: 600;
  color: var(--primary);
  margin-right: 12px;
`;

const RemoveButton = styled.button`
  background: var(--danger-bg);
  border: 1px solid var(--danger-border);
  color: var(--danger);
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
  box-sizing: border-box;
  background-color: var(--card-bg);

  &:hover {
    background: rgba(239, 68, 68, 0.18);
    border-color: rgba(239, 68, 68, 0.35);
    transform: scale(1.05);
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: var(--text-muted);
  
  .icon {
    font-size: 48px;
    margin-bottom: 12px;
    opacity: 0.6;
  }
  
  .text {
    font-size: 1rem;
    font-weight: 500;
  }
`;

const ErrorActions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 20px;
`;

const SummaryTable = styled.div`
  background: var(--panel-bg);
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--input-border);
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid var(--input-border);

  &:last-child {
    border-bottom: none;
    background: rgba(59,130,246,0.10);
    font-weight: 700;
    color: var(--text);
  }
`;

const SummaryLabel = styled.span`
  font-weight: 600;
  color: var(--text);
`;

const SummaryValue = styled.span`
  font-weight: 500;
  color: var(--text);
`;

const FormButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid var(--input-border);

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 10px;
  }
`;

// DODANA: komponenty dla DatePickera (CustomRangeInput, RangeLabelRow, ClearRangeButton, DatepickerZIndexFix, DatepickerTheme)
const CustomRangeInput = React.forwardRef(({ start, end, onClick, placeholderStart, placeholderEnd, className }, ref) => {
  const formatDate = (d) => d ? formatYMD(d) : '';
  return (
    <div className={`range-inputs ${className || ''}`} ref={ref} onClick={onClick}>
      <input type="text" readOnly value={formatDate(start)} placeholder={placeholderStart} aria-label={placeholderStart}/>
      <span className="range-sep">→</span>
      <input type="text" readOnly value={formatDate(end)} placeholder={placeholderEnd} aria-label={placeholderEnd}/>
    </div>
  );
});

const RangeLabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

const ClearRangeButton = styled.button`
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  color: var(--text-muted);
  font-size: 0.65rem;
  padding: 6px 10px;
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: .5px;
  cursor: pointer;
  transition: all .2s;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover:not(:disabled) {
    color: var(--danger);
    border-color: var(--danger);
    background: var(--danger-bg);
  }
  &:disabled {
    opacity: .4;
    cursor: not-allowed;
  }
`;

const DatepickerZIndexFix = styled.div`
  .react-datepicker-popper {
    z-index: var(--z-popover) !important;
  }
`;

const DatepickerTheme = createGlobalStyle`
  .react-datepicker {
    width: 252px;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    background: var(--card-bg);
    border: 1px solid var(--input-border);
    border-radius: 14px;
    box-shadow: 0 10px 34px var(--shadow-color);
    overflow: hidden;
    padding: 0 0 6px 0;
  }
  .react-datepicker__month { margin: 4px 6px 0 6px; }

  .react-datepicker__day.past-day:not(.react-datepicker__day--selected):not(.react-datepicker__day--in-range):not(.react-datepicker__day--keyboard-selected) {
    color: var(--text-muted);
    opacity: 0.6;
  }

  .react-datepicker__triangle { display: none; }

  .react-datepicker-popper[data-placement^="bottom"] {
    margin-top: 6px;
    z-index: var(--z-popover) !important;
  }

  .react-datepicker__header {
    background: var(--primary);
    border-bottom: 1px solid rgba(255,255,255,0.15);
    padding-top: 6px;
    padding-bottom: 4px;
  }

  .react-datepicker__current-month {
    color: var(--primary-contrast);
    font-weight: 600;
    font-size: 0.90rem;
    letter-spacing: .3px;
  }

  .react-datepicker__day-names {
    margin-top: 2px;
  }

  .react-datepicker__day-name {
    color: rgba(255,255,255,0.85);
    font-weight: 500;
    width: 32px;
    line-height: 32px;
    margin: 1px;
    font-size: 0.65rem;
  }

  .react-datepicker__month {
    margin: 4px 6px 0 6px;
  }

  .react-datepicker__week {
    display: flex;
    justify-content: space-between;
  }

  .react-datepicker__day {
    width: 32px;
    height: 32px;
    line-height: 32px;
    margin: 1px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 0.78rem;
    color: var(--text);
    transition: all .15s ease;
    outline: none;
  }

  .react-datepicker__day:hover {
    background: var(--table-row-hover);
    cursor: pointer;
  }

  .react-datepicker__day--outside-month {
    opacity: 0.30;
  }

  .react-datepicker__day--today:not(.react-datepicker__day--selected):not(.react-datepicker__day--in-range) {
    font-weight: 600;
    box-shadow: inset 0 0 0 2px color-mix(in srgb, var(--primary) 45%, transparent);
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background: var(--primary);
    color: var(--primary-contrast) !important;
    box-shadow: var(--shadow-primary);
  }

  .react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range {
    background: color-mix(in srgb, var(--primary) 18%, transparent);
    color: var(--text);
    border-radius: 8px;
  }

  .react-datepicker__day.weekend:not(.react-datepicker__day--selected):not(.react-datepicker__day--in-range):not(.react-datepicker__day--keyboard-selected) {
    color: var(--danger);
  }
  .react-datepicker__day.weekend:hover:not(.react-datepicker__day--selected):not(.react-datepicker__day--in-range) {
    background: var(--danger-bg);
  }

  .react-datepicker__navigation {
    top: 8px;
  }
  .react-datepicker__navigation-icon::before {
    border-color: var(--primary-contrast);
  }

  [data-theme='dark'] .react-datepicker {
    background: var(--panel-bg);
  }

  .range-inputs {
    display: flex;
    align-items: center;
    /* Gdy obie daty nie mieszcza sie w jednym wierszu (telefon 320px), Do przechodzi do drugiego
       wiersza, zamiast ucinac cyfry dnia (przeglad 28.09.2026, to samo co calendar.styles.js). */
    flex-wrap: wrap;
    gap: 4px 10px;
    background: var(--input-bg, rgba(255,255,255,0.06));
    border: 2px solid var(--input-border);
    border-radius: 14px;
    padding: 10px 12px;
    min-height: 44px;
    cursor: pointer;
    transition: border-color .2s, box-shadow .2s, background .2s;
    font-size: 0.95rem;
    width: 100%;
    box-sizing: border-box;
  }

  .range-inputs:focus-within {
    border-color: var(--primary);
    background: var(--card-bg);
    box-shadow: var(--focus-ring);
  }
  .range-inputs input {
    flex: 1;
    /* Bez width 0 pole tekstowe trzyma wrodzona szerokosc (20 znakow, ok. 166px) i rzad Od-Do
       rozpychal formularz na telefonie. Dolna granica to sama data (8 cyfr o stalej szerokosci
       i 2 laczniki, 9.2ch w Arialu), zeby nie ucinac dnia (przeglad 28.09.2026). */
    min-width: 9.2ch;
    width: 0;
    font-variant-numeric: tabular-nums;
    background: transparent;
    border: 0;
    outline: none;
    font-size: 0.95rem;
    font-weight: 500;
    color: var(--text);
    line-height: 1.2;
    padding: 0;
  }
  /* Regula dotyku w index.css daje polom tekstowym min-height 44px (specyficznosc 0,2,1), a tu
     pole jest tylko tekstem w ramce 44px: bez tego rzad mial 68px (przeglad 28.09.2026, pomiar). */
  .range-inputs.range-inputs input {
    min-height: 0;
  }
  .range-inputs input::placeholder {
    color: var(--text-muted);
    font-weight: 400;
  }
  .range-sep {
    font-size: 0.85rem;
    opacity: 0.65;
    user-select: none;
  }

  .range-inputs.filled {
    background: rgba(59,130,246,0.06);
  }
`;

// DODANE: CloseButton dla modala (używany w FormModal)
const ModalCloseButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  background: transparent;
  border: none;
  font-size: 28px;
  color: var(--text-muted);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  
  &:hover {
    background: var(--danger-bg);
    color: var(--danger);
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
  
  @media(max-width: 768px) {
    top: 16px;
    right: 16px;
  }
`;

// DODANE: komponenty dla przycisku Dodaj zaliczke (spójne z calendar.js)
const SecondaryButton = styled.button`
  background: transparent;
  color: var(--text);
  border: 1px solid var(--input-border);
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  gap: 8px;
  align-items: center;
  &:hover { border-color: var(--primary); color: var(--primary); }
`;

// DODANE: pomocnicza funkcja isPastDate
const isPastDate = (date) => {
  if (!date) return false;
  const d = startOfDaySafe(date);
  const today = startOfDaySafe(new Date());
  if (!d || !today) return false;
  return d < today;
};

// DODANE: AddressModal (identyczny jak w calendar.js)
function AddressModal({ isOpen, onClose, values = {}, onSave }) {
  const [local, setLocal] = React.useState({
    street: values.street || '',
    building_number: values.building || '',
    apartment_number: values.apt || '',
    postal_code: values.postal || '',
    city: values.city || ''
  });

  React.useEffect(() => {
    if (!isOpen) return;
    setLocal({
      street: values.street || '',
      building_number: values.building || '',
      apartment_number: values.apt || '',
      postal_code: values.postal || '',
      city: values.city || ''
    });
  }, [isOpen, values]);

  if (!isOpen) return null;

  const handleSave = () => {
    onSave({
      street: local.street || '',
      building: local.building_number || '',
      apt: local.apartment_number || '',
      postal: local.postal_code || '',
      city: local.city || ''
    });
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 6000
    }} onClick={onClose}>
      <div style={{
        background: 'var(--card-bg)', borderRadius: '14px', padding: '20px',
        width: 'min(720px, 96vw)', border: '1px solid var(--input-border)'
      }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
          <h3 style={{ margin: 0, display: 'flex', gap: '8px', alignItems: 'center' }}><MapPinIcon /> {t('equipmentCalendar.editAddress')}</h3>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', fontSize: '20px', cursor: 'pointer' }}>×</button>
        </div>

        <div style={{ display: 'grid', gap: '10px' }}>
          <div>
            <label style={{ fontSize: '.9rem', color: 'var(--text)', display: 'block', marginBottom: '6px' }}>{t('equipmentCalendar.street')}</label>
            <FormInput value={local.street} onChange={e => setLocal(l => ({ ...l, street: e.target.value }))} placeholder={t('equipmentCalendar.street')} />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <div>
              <label style={{ fontSize: '.9rem', color: 'var(--text)', display: 'block', marginBottom: '6px' }}>{t('equipmentCalendar.buildingNo')}</label>
              <FormInput value={local.building_number} onChange={e => setLocal(l => ({ ...l, building_number: e.target.value }))} placeholder={t('equipmentCalendar.buildingNo')} />
            </div>
            <div>
              <label style={{ fontSize: '.9rem', color: 'var(--text)', display: 'block', marginBottom: '6px' }}>{t('equipmentCalendar.apartmentNo')}</label>
              <FormInput value={local.apartment_number} onChange={e => setLocal(l => ({ ...l, apartment_number: e.target.value }))} placeholder={t('equipmentCalendar.phApartmentOptional')} />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <div>
              <label style={{ fontSize: '.9rem', color: 'var(--text)', display: 'block', marginBottom: '6px' }}>{t('equipmentCalendar.postalCode')}</label>
              <FormInput value={local.postal_code} onChange={e => setLocal(l => ({ ...l, postal_code: e.target.value }))} placeholder="00-000" />
            </div>
            <div>
              <label style={{ fontSize: '.9rem', color: 'var(--text)', display: 'block', marginBottom: '6px' }}>{t('equipmentCalendar.city')}</label>
              <FormInput value={local.city} onChange={e => setLocal(l => ({ ...l, city: e.target.value }))} placeholder={t('equipmentCalendar.city')} />
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '6px' }}>
            <SecondaryButton onClick={onClose}>{t('common.cancel')}</SecondaryButton>
            <PrimaryButton onClick={handleSave}>{t('equipmentCalendar.saveAddress')}</PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
}

// DODANE: ikony dla modala sprzętu (SearchIcon, DotIcon już są wcześniej)
// (SearchIcon i DotIcon są już zdefiniowane - pomijam duplikaty)

// DODANE: styled komponenty dla modala wyboru sprzętu (skopiowane z calendar.js)
const CompactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: stretch;
  margin-bottom: 24px;

  & > div {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  @media(max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export default function EquipmentCalendar() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, currentLanguage } = useTranslation();
  const [equipment, setEquipment] = useState(null);
  const [equipmentError, setEquipmentError] = useState(null); // null | 'notfound' | 'failed'
  const [equipmentRetryKey, setEquipmentRetryKey] = useState(0);
  // Dla której sztuki są aktualnie wczytane rezerwacje i blokady ofert. Dopóki nie zgadzają się
  // z `id` z adresu, ekran pokazuje poprzednią sztukę przygaszoną (przełączanie bez szarpnięcia).
  const [rentalsFor, setRentalsForState] = useState(null);
  const rentalsForRef = React.useRef(null);
  const setRentalsFor = (value) => { rentalsForRef.current = value; setRentalsForState(value); };
  const [holdsFor, setHoldsFor] = useState(null);
  const holdsSeq = React.useRef(0);
  const [allEquipment, setAllEquipment] = useState([]);
  const { wymiana } = useZasadyWynajmu();
  const [rentals, setRentals] = useState([]);
  const [offerHolds, setOfferHolds] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [view, setView] = useState('month');
  
  const [activeStartDate, setActiveStartDate] = useState(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1);
  });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showResModal, setShowResModal] = useState(false);
  
  // ZMIENIONY: uproszczony stan formularza (bez email, adresu, rabatu, zaliczki)
  const [resForm, setResForm] = useState({
    firstname: '', 
    lastname: '', 
    phone: '',
    note: '',
  });
  
  const [resDateFrom, setResDateFrom] = useState(null);
  const [resDateTo, setResDateTo] = useState(null);
  const [resSelectedEq, setResSelectedEq] = useState([]);
  const [availableEq, setAvailableEq] = useState([]);
  const [resErrors, setResErrors] = useState({});
  const [resSaving, setResSaving] = useState(false);
  const [availabilityMsg, setAvailabilityMsg] = useState('');
  const [showAddressModal, setShowAddressModal] = useState(false); // nieużywany po zmianach, możesz usunąć
  const [showEquipmentModal, setShowEquipmentModal] = useState(false);

  // DODANA: funkcja ładowania dostępnego sprzętu
  const loadEditData = React.useCallback(async () => {
    if (!resDateFrom || !resDateTo) {
      setAvailabilityMsg(t('equipmentCalendar.pickRangeFirst'));
      return;
    }
    try {
      const params = new URLSearchParams({
        start: formatYMD(resDateFrom),
        end: formatYMD(resDateTo)
      });
      const res = await axios.get(`${API_BASE}/api/equipment/available?${params.toString()}`, { withCredentials: true });
      setAvailableEq(res.data);
      setAvailabilityMsg('');
    } catch (err) {
      console.error('Błąd ładowania sprzętu:', err);
      setAvailabilityMsg(t('equipmentCalendar.loadAvailableFailed'));
    }
  }, [resDateFrom, resDateTo]);

  // DODANA: funkcja zamykania modala z resetem formularza
  const closeResModal = () => {
    setShowResModal(false);
    // Reset wszystkich pól formularza
    setResForm({ firstname: '', lastname: '', phone: '', note: '' });
    setResDateFrom(null);
    setResDateTo(null);
    setResSelectedEq([]);
    setResErrors({});
    setAvailabilityMsg('');
  };

  // DODANA: funkcja toggle sprzętu
  const handleEquipmentToggle = (equipmentId) => {
    const normalize = (v) => {
      if (v == null) return v;
      if (typeof v === 'number') return v;
      if (typeof v === 'string' && /^\d+$/.test(v)) return Number(v);
      return v;
    };
    const id = normalize(equipmentId);
    setResSelectedEq(prev => {
      const prevIds = Array.isArray(prev) ? prev.map(normalize) : [];
      const has = prevIds.includes(id);
      const nextIds = has ? prevIds.filter(i => i !== id) : [...prevIds, id];
      return nextIds;
    });
  };

  useEffect(() => {
    axios.get(`${API_BASE}/api/equipment`, { withCredentials: true })
      .then(res => setAllEquipment(res.data))
      .catch(err => console.error('Błąd pobierania listy sprzętu:', err));
  }, []);

  useEffect(() => {
    // spóźniona odpowiedź po zmianie id/retry nie może nadpisać nowszego stanu
    let stale = false;
    setEquipmentError(null);
    if (id === 'all') {
      setEquipment({
        id: 'all',
        name: t('equipmentCalendar.allEquipment'),
        inventory_number: null,
        brand: '-',
        size: '-',
        category: 'all'
      });
    } else {
      // Przełączenie na inną sztukę NIE czyści ekranu (dawniej cała strona na moment zamieniała
      // się w „Ładowanie...", co dawało szarpnięcie): nazwa nowej sztuki pojawia się od razu
      // z listy sprzętu, a pełne dane dociąga zapytanie niżej. Pusty ekran tylko przy pierwszym wejściu.
      setEquipment((prev) => (prev ? (allEquipment.find((e) => String(e.id) === String(id)) || prev) : null));
      axios.get(`${API_BASE}/api/equipment/${id}`, { withCredentials: true })
        .then(res => { if (!stale) setEquipment(res.data); })
        .catch(err => {
          console.error('Błąd pobierania sprzętu:', err);
          if (!stale) setEquipmentError(err?.response?.status === 404 ? 'notfound' : 'failed');
        });
    }
    return () => { stale = true; };
  }, [id, equipmentRetryKey]);

  // U.28: /api/rentals bez parametrów oddaje 200 NAJSTARSZYCH rezerwacji firmy, więc kalendarz
  // sztuki gubił nowe. Pytamy o okno, które ekran pokazuje: siatkę miesiąca, wybrany dzień
  // (panel boczny) i najbliższe 30 dni (stan „wypożyczony dziś" i lista aktywnych) — rezerwacje
  // NACHODZĄCE na okno, także zaczęte przed nim. Sztukę filtruje serwer, więc limit nie zjada
  // jej rezerwacji rezerwacjami innych sztuk. Trzy zakresy idą OSOBNYMI oknami (scalane tylko,
  // gdy się stykają): jedno rozciągnięte „od dziś do miesiąca za pół roku" serwer ucinał
  // limitem od najstarszych, więc w widoku wszystkich sztuk odpadał oglądany miesiąc, a przy
  // przewijaniu wstecz — dzisiejsze wypożyczenia.
  const rentalsWindows = React.useMemo(
    () => mergeWindows([monthGridWindow(activeStartDate), daysWindow(selectedDate), daysWindow(new Date(), 30)]),
    [activeStartDate, selectedDate]
  );
  const rentalsWindowKey = windowsKey(rentalsWindows);
  const rentalsSeq = React.useRef(0);

  const loadRentals = async () => {
    const seq = ++rentalsSeq.current;
    const equipmentId = id === 'all' ? undefined : parseInt(id, 10);
    try {
      const responses = await Promise.all(rentalsWindows.map((win) => axios.get(
        `${API_BASE}/api/rentals${reservationListQuery(win, {
          equipmentId: Number.isFinite(equipmentId) ? equipmentId : undefined,
          limit: 2000,
        })}`,
        { withCredentials: true }
      )));
      if (seq !== rentalsSeq.current) return; // nowsze okno albo inna sztuka już w drodze
      const list = mergeReservationLists(...responses.map((res) => (Array.isArray(res.data) ? res.data : [])));
      setRentals(id === 'all'
        ? list
        : list.filter(rental => Array.isArray(rental.equipment) && rental.equipment.includes(equipmentId)));
      setRentalsFor(id);
    } catch (err) {
      console.error('Błąd pobierania wypożyczeń:', err);
      if (seq !== rentalsSeq.current) return;
      // Po zmianie sztuki nie zostawiamy rezerwacji POPRZEDNIEJ pod nazwą nowej.
      const taSamaSztuka = rentalsForRef.current === id; // odczyt PRZED zmianą znacznika niżej
      setRentals((prev) => (taSamaSztuka ? prev : []));
      setRentalsFor(id);
    }
  };

  useEffect(() => {
    loadRentals();
  }, [id, equipmentRetryKey, rentalsWindowKey]);

  // Holdy ofert (aktywne, ważne wg expires_at) dla widocznego miesiąca
  useEffect(() => {
    const seq = ++holdsSeq.current;
    const fetchOfferHolds = async () => {
      try {
        // Siatka miesiąca ORAZ najbliższe 30 dni: agenda z prawej pokazuje oferty od dziś, więc
        // samo okno oglądanego miesiąca gubiło pod jego koniec oferty z następnego.
        const monthStart = new Date(activeStartDate.getFullYear(), activeStartDate.getMonth(), 1);
        const monthEnd = new Date(activeStartDate.getFullYear(), activeStartDate.getMonth() + 1, 0);
        const dzis = new Date();
        const zaMiesiac = new Date(dzis.getFullYear(), dzis.getMonth(), dzis.getDate() + 30);

        const params = new URLSearchParams({
          start: formatYMD(monthStart < dzis ? monthStart : dzis),
          end: formatYMD(monthEnd > zaMiesiac ? monthEnd : zaMiesiac)
        });

        if (id !== 'all' && /^\d+$/.test(String(id))) {
          params.set('equipmentId', String(id));
        }

        const res = await axios.get(`${API_BASE}/api/offer-holds?${params.toString()}`, { withCredentials: true });
        // spóźniona odpowiedź poprzedniej sztuki albo miesiąca nie nadpisuje nowszej
        if (seq !== holdsSeq.current) return;
        setOfferHolds(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error('Błąd pobierania holdów ofert:', err);
        if (seq !== holdsSeq.current) return;
        setOfferHolds([]);
      }
      setHoldsFor(id);
    };

    fetchOfferHolds();
  }, [id, activeStartDate]);

  const filteredEquipment = allEquipment.filter(item => {
    const query = searchQuery.toLowerCase();
    return (
      item.name?.toLowerCase().includes(query) ||
      item.inventory_number?.toLowerCase().includes(query) ||
      item.brand?.toLowerCase().includes(query)
    );
  });

  const handleEquipmentChange = (equipmentId) => {
    setDropdownOpen(false);
    setSearchQuery('');
    navigate(`/inventory/${equipmentId}/calendar`);
  };

  const isAllView = id === 'all';

  // Jedna lista wpisów (rezerwacje + blokady ofert) zasila cały ekran: wstęgi w siatce, zdanie
  // o stanie sztuki, obłożenie miesiąca i agendę (utils/equipmentSchedule.js). Wcześniej każde
  // z tych miejsc liczyło „czy dzień jest zajęty" po swojemu.
  const entries = React.useMemo(() => buildEntries(rentals, offerHolds), [rentals, offerHolds]);
  const lanes = React.useMemo(() => assignLanes(entries), [entries]);
  const tag = localeTag(currentLanguage);

  // Przełączanie sztuki (albo na widok zbiorczy): dopóki dane nowej sztuki nie dotarły, stara
  // zawartość zostaje przygaszona, a po ich dotarciu nowa wchodzi krótkim przenikaniem — klucz
  // widoku zmienia się dopiero wtedy, więc animacja gra na GOTOWYCH danych, nie na pustym ekranie.
  const przelaczanie = String(rentalsFor) !== String(id) || String(holdsFor) !== String(id)
    || !equipment || String(equipment.id) !== String(id);
  const gotowyWidokRef = React.useRef(id);
  if (!przelaczanie) gotowyWidokRef.current = id;
  const kluczWidoku = String(gotowyWidokRef.current);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setActiveStartDate(new Date(date.getFullYear(), date.getMonth(), 1));
  };

  // Klik we wpis agendy: wybiera dzień jego początku, a siatka przechodzi na ten miesiąc.
  const focusEntry = (entry) => {
    handleDateChange(entry.start);
    setView('month');
  };

  const goToToday = () => {
    handleDateChange(new Date());
    setView('month');
  };

  // Szczegóły rezerwacji są w kalendarzu rezerwacji; ten sam link co ze strony głównej i płatności.
  const openReservation = (entry) => {
    navigate(`/calendar?date=${encodeURIComponent(formatYMD(entry.start))}&reservationId=${encodeURIComponent(entry.id)}`);
  };

  const MAX_LANES = 3;

  const tileContent = ({ date, view }) => {
    if (view !== 'month') return null;
    const onDay = entriesOnDay(entries, date);
    if (onDay.length === 0) return null;

    if (isAllView) {
      const res = onDay.filter((e) => e.kind === 'reservation').length;
      const off = onDay.filter((e) => e.kind === 'offer').length;
      return (
        <DayCounts aria-hidden="true">
          {res > 0 && <DayCount $kind="reservation">{res}</DayCount>}
          {off > 0 && <DayCount $kind="offer">{off}</DayCount>}
        </DayCounts>
      );
    }

    const visible = onDay.filter((e) => (lanes.get(entryKey(e)) ?? 0) < MAX_LANES);
    const hidden = onDay.length - visible.length;
    return (
      <>
        {visible.map((e) => {
          const piece = ribbonPiece(e, date);
          const isOffer = e.kind === 'offer';
          // wyciszona cała ZAKOŃCZONA wstęga, nie dni sprzed dziś: trwająca rezerwacja ma jeden kolor
          const past = e.end < today;
          return (
            <Ribbon
              key={entryKey(e)}
              aria-hidden="true"
              data-cy="equipment-calendar-ribbon"
              data-kind={e.kind}
              $lane={lanes.get(entryKey(e)) ?? 0}
              $offer={isOffer}
              $past={past}
              $color={isOffer ? undefined : reservationColor(e.id)}
              $roundLeft={piece.roundLeft}
              $roundRight={piece.roundRight}
            >
              {piece.showLabel && (
                <RibbonLabel $offer={isOffer} $past={past} $span={piece.spanDays}>
                  {e.name || (isOffer ? t('equipmentCalendar.legendOffer') : t('equipmentCalendar.kindReservation'))}
                </RibbonLabel>
              )}
            </Ribbon>
          );
        })}
        {hidden > 0 && <MoreBadge title={t('equipmentCalendar.moreOnDay', { count: hidden })}>+{hidden}</MoreBadge>}
      </>
    );
  };

  const tileClassName = ({ date, view }) => (view === 'month' && date < today ? 'is-past' : null);

  const fmtShort = (d) => d.toLocaleDateString(tag, { day: 'numeric', month: 'numeric' });
  const fmtLong = (d) => d.toLocaleDateString(tag, { day: 'numeric', month: 'long' });
  const fmtRange = (e) => (e.start.getTime() === e.end.getTime() ? fmtShort(e.start) : `${fmtShort(e.start)} - ${fmtShort(e.end)}`);
  const dniLabel = (n) => {
    switch (new Intl.PluralRules(tag).select(n)) {
      case 'one': return t('equipmentCalendar.daysOne', { count: n });
      case 'few': return t('equipmentCalendar.daysFew', { count: n });
      case 'many': return t('equipmentCalendar.daysMany', { count: n });
      default: return t('equipmentCalendar.daysOther', { count: n });
    }
  };
  const equipmentNames = (ids) => (ids || [])
    .map((eid) => allEquipment.find((x) => x.id === eid)?.name)
    .filter(Boolean)
    .join(', ');

  const status = itemStatus(entries, today, { wymiana, equipmentId: parseInt(id, 10) });
  const occupancy = monthOccupancy(entries, activeStartDate);
  const occupancyPct = occupancy.totalDays ? Math.round((occupancy.busyDays / occupancy.totalDays) * 100) : 0;
  const dayEntries = entriesOnDay(entries, selectedDate);
  const upcoming = agenda(entries, today, 30);

  const statusView = (() => {
    if (isAllView) return { tone: 'neutral', line: t('equipmentCalendar.aggregateView'), sub: t('equipmentCalendar.aggregateHint') };
    if (status.state === 'rented') {
      return { tone: 'rented', line: t('equipmentCalendar.statusRented', { date: fmtLong(status.until) }), sub: status.entry.name };
    }
    if (status.state === 'held') {
      return { tone: 'held', line: t('equipmentCalendar.statusHeld', { date: fmtLong(status.until) }), sub: t('equipmentCalendar.offerFor', { name: status.entry.name || '' }) };
    }
    return {
      tone: 'free',
      line: t('equipmentCalendar.statusFree'),
      sub: status.next
        ? t('equipmentCalendar.statusNext', { range: fmtRange(status.next), name: status.next.name || t('common.noData') })
        : t('equipmentCalendar.statusNoNext'),
    };
  })();

  const renderAgendaItem = (e) => {
    const isOffer = e.kind === 'offer';
    const names = isAllView ? equipmentNames(e.equipmentIds) : '';
    const meta = isOffer
      ? t('equipmentCalendar.legendOfferHold')
      : [t('equipmentCalendar.kindReservation'), e.status].filter(Boolean).join(' · ');
    return (
      <AgendaItem key={entryKey(e)} data-cy="equipment-calendar-entry" data-kind={e.kind}>
        <AgendaStripe $offer={isOffer} $color={isOffer ? undefined : reservationColor(e.id)} />
        <AgendaMain type="button" onClick={() => focusEntry(e)} title={t('equipmentCalendar.showInCalendar')}>
          <AgendaDates>
            {fmtRange(e)} <span>· {dniLabel(daysBetweenInclusive(e.start, e.end))}</span>
          </AgendaDates>
          <AgendaName>{e.name || t('common.noData')}</AgendaName>
          {names && <AgendaMeta>{names}</AgendaMeta>}
          <AgendaMeta>{meta}</AgendaMeta>
        </AgendaMain>
        {!isOffer && (
          <OpenButton
            type="button"
            onClick={() => openReservation(e)}
            title={t('equipmentCalendar.openTitle')}
            data-cy="equipment-calendar-open"
          >
            {t('equipmentCalendar.open')}
          </OpenButton>
        )}
      </AgendaItem>
    );
  };


  useEffect(() => {
    if (!resDateFrom || !resDateTo) return;
    const fetchAvailable = async () => {
      try {
        const params = new URLSearchParams({
          start: formatYMD(resDateFrom),
          end: formatYMD(resDateTo),
        }).toString();
        const { data } = await axios.get(`${API_BASE}/api/equipment/available?${params}`, { withCredentials: true });
        setAvailableEq(data);
        const allowed = new Set(data.map(e => e.id));
        setResSelectedEq(prev => prev.filter(id => allowed.has(id)));
        setAvailabilityMsg('');
      } catch {
        setAvailabilityMsg(t('equipmentCalendar.checkAvailabilityFailed'));
      }
    };
    fetchAvailable();
  }, [resDateFrom, resDateTo]);

  // ZMIENIONE: Obliczenia kosztów i kaucji - zawsze 0 dla blokady
  const resDays = daysInclusive(resDateFrom, resDateTo);
  const resBillableDays = resDays; // nie liczymy "płatnych" dni
  const resIsLong = false;
  const resEqObjects = availableEq.filter(e => resSelectedEq.includes(e.id));
  const resTotalPrice = 0;
  const resDiscountValue = 0;
  const resToPay = 0;
  const resEffectiveToPay = 0;
  const resDeposit = 0;

  // ZMIENIONA: Walidacja bez email
  const validateResForm = () => {
    const errs = {};
    if (!resForm.firstname.trim()) errs.firstname = t('equipmentCalendar.firstnameRequired');
    if (!resForm.lastname.trim()) errs.lastname = t('equipmentCalendar.lastnameRequired');
    if (!resForm.phone.trim()) errs.phone = t('equipmentCalendar.phoneRequired');
    if (!resDateFrom || !resDateTo) errs.dates = t('equipmentCalendar.rangeRequired');
    if (!resSelectedEq.length) errs.equipment = t('equipmentCalendar.equipmentRequired');
    return errs;
  };

  // ZMIENIONA: Zapis rezerwacji (blokady) z cenami=0, status "W trakcie" (ID=2)
  const submitReservation = async () => {
    const errs = validateResForm();
    setResErrors(errs);
    if (Object.keys(errs).length) return;

    setResSaving(true);
    try {
      const payload = {
        firstname: resForm.firstname,
        lastname: resForm.lastname,
        phone: resForm.phone,
        note: resForm.note,
        discount: 0,
        discountUnit: 'PLN',
        dateFrom: formatYMD(resDateFrom),
        dateTo: formatYMD(resDateTo),
        equipment: resSelectedEq,
        totalPrice: 0,
        advance_amount: 0,
        advance_paid: false,
        deposit_override: 0,
        clientless: true,
        // Używamy statusu "W trakcie" (ID=2) jako domyślnego dla blokady
        // Możesz dodać status "Blokada" w Reservation_Status i tu przekazać jego ID
        reservation_status_id: 2,
      };
      const csrf = localStorage.getItem('csrfToken') || '';
      const response = await axios.post(`${API_BASE}/api/reservation`, payload, {
        withCredentials: true,
        headers: { 'X-CSRF-Token': csrf }
      });
      if (response.status === 200 || response.status === 201) {
        // U.28: to samo okno i ten sam filtr sztuki co przy wczytaniu (dawniej wstawiało tu
        // rezerwacje WSZYSTKICH sztuk, także w kalendarzu pojedynczej).
        await loadRentals();
        setShowResModal(false);
        // Reset formularza po zapisie
        setResForm({ firstname: '', lastname: '', phone: '', note: '' });
        setResDateFrom(null);
        setResDateTo(null);
        setResSelectedEq([]);
      } else {
        throw new Error(response.data?.message || t('equipmentCalendar.saveError'));
      }
    } catch (e) {
      // Komunikat serwera, gdy jest (np. 409 equipment_conflict: która sztuka i kiedy jest zajęta).
      // Samo `e.message` z axiosa to „Request failed with status code 409”.
      setResErrors(prev => ({ ...prev, submit: e?.response?.data?.message || e?.message || t('equipmentCalendar.saveReservationFailed') }));
    } finally {
      setResSaving(false);
    }
  };

  // DODANA: funkcja sprawdzająca czy wszystkie obowiązkowe pola są wypełnione
  const isFormValid = React.useMemo(() => {
    return (
      resForm.firstname.trim() !== '' &&
      resForm.lastname.trim() !== '' &&
      resForm.phone.trim() !== '' &&
      resDateFrom !== null &&
      resDateTo !== null &&
      resSelectedEq.length > 0
    );
  }, [resForm.firstname, resForm.lastname, resForm.phone, resDateFrom, resDateTo, resSelectedEq]);

  // Terminalny stan błędu/braku sprzętu — zamiast wiecznego „Ładowanie..." (U.2)
  if (equipmentError) {
    return (
      <Container>
        <EmptyState data-cy="equipment-calendar-error">
          <div className="icon">{equipmentError === 'notfound' ? <UiSearchIcon size={40} /> : <AlertIcon size={40} />}</div>
          <div className="text">
            {equipmentError === 'notfound'
              ? t('equipmentCalendar.notFound')
              : t('equipmentCalendar.loadFailed')}
          </div>
          <ErrorActions>
            {equipmentError === 'failed' && (
              <PrimaryButton
                data-cy="equipment-calendar-retry"
                onClick={() => setEquipmentRetryKey(k => k + 1)}
              >
                {t('common.retry')}
              </PrimaryButton>
            )}
            <SecondaryButtonGhost onClick={() => navigate('/inventory')}>
              <ArrowLeftIcon /> {t('equipmentCalendar.backToInventory')}
            </SecondaryButtonGhost>
          </ErrorActions>
        </EmptyState>
      </Container>
    );
  }

  // Jeśli sprzęt nie załadowany — zwróć widok ładowania (po wszystkich hookach)
  if (!equipment) {
    return (
      <Container>
        <Title data-cy="equipment-calendar-loading">{t('equipmentCalendar.loading')}</Title>
      </Container>
    );
  }
  
  return (
    <Container>
      <Header>
        <TitleSection>
          {/* Standardowa strzalka powrotu (IconButton + ArrowLeftIcon z ui/common.js i
              ui/icons.js) zamiast opisanego przycisku „Powrót do magazynu" — tak jak na
              podstronach profilu (Security.js, YourData.js...). */}
          <IconButton onClick={() => navigate('/inventory')} aria-label={t('addEquipment.backToInventory')}>
            <ArrowLeftIcon />
          </IconButton>
          <TitleIcon>
            <CalendarIcon />
          </TitleIcon>
          <Title>{t('equipmentCalendar.title')}</Title>
        </TitleSection>
        <ActionButtons>
          <PrimaryButton data-cy="equipment-calendar-book" onClick={() => {
            if (id !== 'all') setResSelectedEq([Number(id)]);
            else setResSelectedEq([]);
            setShowResModal(true);
          }}>
            <PlusIcon /> {t('equipmentCalendar.bookEquipment')}
          </PrimaryButton>
        </ActionButtons>
      </Header>

      <ItemBar>
        <EquipmentSelector>
          <SelectorButton type="button" aria-expanded={dropdownOpen} onClick={() => setDropdownOpen(!dropdownOpen)}>
            <SelectorLabel>
              <SelectorTitle>{t('equipmentCalendar.selectedEquipment')}</SelectorTitle>
              <SelectorValue>
                {equipment.name}
                {equipment.inventory_number && <SelectorNumber>{equipment.inventory_number}</SelectorNumber>}
              </SelectorValue>
            </SelectorLabel>
            <ChevronDownIcon />
          </SelectorButton>

          <DropdownMenu isOpen={dropdownOpen}>
            <SearchInput
              type="text"
              placeholder={t('equipmentCalendar.searchEquipment')}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />

            <DropdownItem
              isActive={id === 'all'}
              onClick={() => handleEquipmentChange('all')}
            >
              <ItemName>{t('equipmentCalendar.allEquipment')}</ItemName>
              <ItemDetails>{t('equipmentCalendar.aggregateView')}</ItemDetails>
            </DropdownItem>

            {filteredEquipment.map(item => (
              <DropdownItem
                key={item.id}
                isActive={item.id === parseInt(id)}
                onClick={() => handleEquipmentChange(item.id)}
              >
                <ItemName>{item.name}</ItemName>
                <ItemDetails>
                  {[item.inventory_number, item.brand, item.size].filter(Boolean).join(' · ')}
                </ItemDetails>
              </DropdownItem>
            ))}
          </DropdownMenu>
        </EquipmentSelector>

        <StatusBlock
          key={kluczWidoku}
          $busy={przelaczanie}
          aria-busy={przelaczanie}
          data-cy="equipment-calendar-status"
          data-state={isAllView ? 'all' : status.state}
        >
          <StatusLine><StatusDot $tone={statusView.tone} aria-hidden="true" />{statusView.line}</StatusLine>
          {statusView.sub && <StatusSub>{statusView.sub}</StatusSub>}
          {!isAllView && (
            <Occupancy>
              <span>
                {t('equipmentCalendar.occupancy', {
                  month: activeStartDate.toLocaleDateString(tag, { month: 'long' }),
                  busy: occupancy.busyDays,
                  total: occupancy.totalDays,
                })}
              </span>
              <OccupancyTrack aria-hidden="true"><span style={{ width: `${occupancyPct}%` }} /></OccupancyTrack>
            </Occupancy>
          )}
        </StatusBlock>
      </ItemBar>

      <MainContent key={kluczWidoku} $busy={przelaczanie} aria-busy={przelaczanie}>
        <CalendarCard>
          <Calendar
            onChange={handleDateChange}
            value={selectedDate}
            activeStartDate={activeStartDate}
            onActiveStartDateChange={({ activeStartDate }) => setActiveStartDate(activeStartDate)}

            view={view}
            onViewChange={({ view }) => setView(view)}
            onClickMonth={() => setView('month')}
            onClickYear={() => setView('year')}
            onClickDecade={() => setView('decade')}

            tileContent={tileContent}
            tileClassName={tileClassName}
            /* P8.1e (3/5): język KALENDARZA zostaje polski i NIE jest to przeoczenie.
               Nazwa miesiąca idzie przez `toLocaleDateString('pl-PL')`, skróty dni z tablicy
               niżej, a `react-datepicker` w formularzu rezerwacji używa `date-fns/locale/pl`
               zarejestrowanego na sztywno. Przetłumaczenie SAMYCH skrótów dni dałoby niemieckie
               „Mo/Di/Mi" pod polskim „sierpień 2026" w tym samym nagłówku — czyli dokładnie ten
               rozjazd, który wytknęło review części 1/4. Przełączanie lokalizacji dat to osobne
               zadanie (trzy biblioteki, import locale per język), nie wyciąganie napisów. */
            locale="pl-PL"
            formatMonthYear={(locale, date) =>
              new Date(date).toLocaleDateString('pl-PL', { month: 'long', year: 'numeric' })
            }
            formatShortWeekday={(locale, date) => {
              const days = ["Nie", "Pon", "Wto", "Śro", "Czw", "Pią", "Sob"];
              return days[date.getDay()];
            }}
            // Tytuł dekady i stulecia („2021 – 2030”) react-calendar składa z półpauzą; u nas zwykły myślnik.
            navigationLabel={({ label }) => label.replace(/–/g, '-')}
          />

          <CalendarFooter>
            <Legend>
              {isAllView ? (
                <>
                  <LegendItem><DayCount $kind="reservation" aria-hidden="true">2</DayCount>{t('equipmentCalendar.reservations')}</LegendItem>
                  <LegendItem><DayCount $kind="offer" aria-hidden="true">1</DayCount>{t('equipmentCalendar.legendOfferHold')}</LegendItem>
                </>
              ) : (
                <>
                  <LegendItem><LegendSwatch $kind="reservation" aria-hidden="true" />{t('equipmentCalendar.kindReservation')}</LegendItem>
                  <LegendItem><LegendSwatch $kind="offer" aria-hidden="true" />{t('equipmentCalendar.legendOfferHold')}</LegendItem>
                </>
              )}
              <LegendItem><LegendSwatch $kind="today" aria-hidden="true" />{t('equipmentCalendar.legendToday')}</LegendItem>
            </Legend>
            <TodayButton type="button" onClick={goToToday}>{t('equipmentCalendar.goToday')}</TodayButton>
          </CalendarFooter>
        </CalendarCard>

        <Agenda>
          <AgendaSection data-cy="equipment-calendar-day">
            <AgendaEyebrow>{t('equipmentCalendar.selectedDay')}</AgendaEyebrow>
            <AgendaHeading>{selectedDate.toLocaleDateString(tag, { weekday: 'long', day: 'numeric', month: 'long' })}</AgendaHeading>
            {dayEntries.length > 0
              ? <AgendaList>{dayEntries.map(renderAgendaItem)}</AgendaList>
              : <AgendaEmpty>{isAllView ? t('equipmentCalendar.dayEmptyAll') : t('equipmentCalendar.dayEmpty')}</AgendaEmpty>}
          </AgendaSection>

          <AgendaSection data-cy="equipment-calendar-upcoming">
            <AgendaEyebrow>{t('equipmentCalendar.next30')}</AgendaEyebrow>
            {upcoming.length > 0
              ? <AgendaList>{upcoming.map(renderAgendaItem)}</AgendaList>
              : <AgendaEmpty>{t('equipmentCalendar.next30Empty')}</AgendaEmpty>}
          </AgendaSection>
        </Agenda>
      </MainContent>

      {showResModal && (
        <FormModal onClick={closeResModal}>
          <FormContainer onClick={e => e.stopPropagation()} data-cy="equipment-calendar-form">
            <ModalCloseButton onClick={closeResModal} title={t('common.close')}>×</ModalCloseButton>

            <FormHeader>
              <FormTitle>
                <CalendarIcon />
                {t('equipmentCalendar.newReservation')}
              </FormTitle>
              <FormSubtitle>
                {t('equipmentCalendar.newReservationHint')}
              </FormSubtitle>
            </FormHeader>

            {resErrors.submit && (
              <FormPanel style={{ borderColor: 'var(--danger)', background: 'var(--danger-bg)' }}>
                <FormPanelHeader>
                  <FormPanelIcon $tone="danger">
                    <XIcon />
                  </FormPanelIcon>
                  <FormPanelTitle>{t('equipmentCalendar.errorPanel')}</FormPanelTitle>
                </FormPanelHeader>
                <div style={{ fontWeight: 600 }}>{resErrors.submit}</div>
              </FormPanel>
            )}

            {/* Dane podstawowe */}
            <FormPanel>
              <FormPanelHeader>
                <FormPanelIcon $tone="steel"><UserIcon /></FormPanelIcon>
                <FormPanelTitle>{t('equipmentCalendar.basicData')}</FormPanelTitle>
              </FormPanelHeader>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', '@media(max-width: 768px)': { gridTemplateColumns: '1fr' } }}>
                <FormInputWrapper>
                  <FormLabel><UserIcon /> {t('equipmentCalendar.firstname')}</FormLabel>
                  <FormInput type="text" value={resForm.firstname} onChange={e => setResForm(p => ({...p, firstname: e.target.value}))} placeholder={t('equipmentCalendar.phFirstname')} required />
                  {resErrors.firstname && <ErrorText>{resErrors.firstname}</ErrorText>}
                </FormInputWrapper>
                <FormInputWrapper>
                  <FormLabel><UserIcon /> {t('equipmentCalendar.lastname')}</FormLabel>
                  <FormInput type="text" value={resForm.lastname} onChange={e => setResForm(p => ({...p, lastname: e.target.value}))} placeholder={t('equipmentCalendar.phLastname')} required />
                  {resErrors.lastname && <ErrorText>{resErrors.lastname}</ErrorText>}
                </FormInputWrapper>
                <FormInputWrapper>
                  <FormLabel><PhoneIcon /> {t('equipmentCalendar.phone')}</FormLabel>
                  <FormInput type="tel" value={resForm.phone} onChange={e => setResForm(p => ({...p, phone: e.target.value}))} placeholder={t('equipmentCalendar.phPhone')} required />
                  {resErrors.phone && <ErrorText>{resErrors.phone}</ErrorText>}
                </FormInputWrapper>
              </div>
            </FormPanel>

            {/* ZMIENIONE: Termin rezerwacji + Notatki obok siebie */}
            <CompactGrid>
              {/* Panel: Termin rezerwacji */}
            <FormPanel>
              <FormPanelHeader>
                <FormPanelIcon $tone="dusk"><CalendarIcon /></FormPanelIcon>
                <FormPanelTitle>{t('equipmentCalendar.reservationRange')}</FormPanelTitle>
              </FormPanelHeader>
              <DatepickerZIndexFix>
                <FormInputWrapper style={{maxWidth: '100%'}}>
                  <RangeLabelRow>
                    <FormLabel style={{marginBottom: 0}}><CalendarIcon /> {t('equipmentCalendar.dateRange')}</FormLabel>
                    <ClearRangeButton
                      type="button"
                      onClick={() => { setResDateFrom(null); setResDateTo(null); }}
                      disabled={false}
                      title={t('equipmentCalendar.clearRange')}
                    >
                      {t('common.clear')}
                    </ClearRangeButton>
                  </RangeLabelRow>
                  <DatePicker
                    popperModifiers={DOSUN_DO_EKRANU}
                    selected={resDateFrom || null}
                    onChange={(dates) => {
                      const [start, end] = dates || [null, null];
                      setResDateFrom(start || null);
                      setResDateTo(end || null);
                    }}
                    startDate={resDateFrom || null}
                    endDate={resDateTo || null}
                    selectsRange
                    locale="pl"
                    dateFormat="yyyy-MM-dd"
                    shouldCloseOnSelect={false}
                    customInput={
                      <CustomRangeInput
                        start={resDateFrom}
                        end={resDateTo}
                        placeholderStart={t('equipmentCalendar.rangeFrom')}
                        placeholderEnd={t('equipmentCalendar.rangeTo')}
                      />
                    }
                    dayClassName={(date) => {
                      const classes = [];
                      const day = date.getDay();
                      if (day === 0 || day === 6) classes.push('weekend');
                      if (isPastDate(date)) classes.push('past-day');
                      return classes.join(' ');
                    }}
                  />
                  {resErrors.dates && <ErrorText>{resErrors.dates}</ErrorText>}
                </FormInputWrapper>
              </DatepickerZIndexFix>
            </FormPanel>

              {/* Panel: Notatki */}
              <FormPanel>
                <FormPanelHeader>
                  <FormPanelIcon $tone="clay"><FileTextIcon /></FormPanelIcon>
                  <FormPanelTitle>{t('equipmentCalendar.notes')}</FormPanelTitle>
                </FormPanelHeader>
                <FormInputWrapper>
                  <FormTextarea
                    value={resForm.note || ''}
                    onChange={e => setResForm(p => ({...p, note: e.target.value}))}
                    placeholder={t('equipmentCalendar.notePlaceholder')}
                    style={{ minHeight: '120px' }}
                  />
                </FormInputWrapper>
              </FormPanel>
            </CompactGrid>

            {/* Wybrany sprzęt */}
            <FormPanel>
              <FormPanelHeader>
                <FormPanelIcon $tone="pine"><PackageIcon /></FormPanelIcon>
                <FormPanelTitle>{t('equipmentCalendar.selectedEquipmentRequired')}</FormPanelTitle>
                <PrimaryButton
                  type="button"
                  onClick={async () => {
                    await loadEditData();
                    setShowEquipmentModal(true);
                  }}
                  style={{ marginLeft: 'auto' }}
                  disabled={!resDateFrom || !resDateTo}
                  data-cy="equipment-calendar-open-equipment"
                  title={!resDateFrom || !resDateTo ? t('equipmentCalendar.pickRangeFirstShort') : t('equipmentCalendar.equipmentRequired')}
                >
                  <PlusIcon /> {t('equipmentCalendar.equipmentRequired')}
                </PrimaryButton>
              </FormPanelHeader>

              {resSelectedEq.length > 0 ? (
                <FormEquipmentList>
                  {availableEq
                    .filter(eq => resSelectedEq.includes(eq.id))
                    .map(equipment => (
                      <EquipmentItemRow key={equipment.id}>
                        <EquipmentInfoRow>
                          <PackageIcon />
                          <div>
                            <EquipmentNameText>{equipment.name}</EquipmentNameText>
                            <br />
                            <EquipmentMeta>
                              {equipment.inventory_number && `Nr: ${equipment.inventory_number} • `}{equipment.class} • {equipment.category} • Rozmiar: {equipment.size}
                            </EquipmentMeta>
                          </div>
                        </EquipmentInfoRow>
                        <div style={{display:'flex', alignItems:'center', gap:12}}>
                          <RemoveButton
                            type="button"
                            onClick={() => handleEquipmentToggle(equipment.id)}
                            title={t('equipmentCalendar.removeFromReservation')}
                          >
                            <TrashIcon />
                          </RemoveButton>
                        </div>
                      </EquipmentItemRow>
                    ))}
                </FormEquipmentList>
              ) : (
                <EmptyState>
                  <div className="icon"><PackageIcon /></div>
                  <div className="text">
                    {!resDateFrom || !resDateTo 
                      ? t('equipmentCalendar.emptyPickRange')
                      : t('equipmentCalendar.emptyPickEquipment')}
                  </div>
                </EmptyState>
              )}
              {resErrors.equipment && <ErrorText style={{marginTop:8}}>{resErrors.equipment}</ErrorText>}
            </FormPanel>

            {/* ZMIENIONE: Podsumowanie - tylko liczba dni */}
            <FormPanel>
              <FormPanelHeader>
                <FormPanelIcon $tone="gold"><CreditCardIcon /></FormPanelIcon>
                <FormPanelTitle>{t('equipmentCalendar.summary')}</FormPanelTitle>
              </FormPanelHeader>
              <SummaryTable>
                <SummaryRow>
                  <SummaryLabel>{t('equipmentCalendar.dayCount')}</SummaryLabel>
                  <SummaryValue>{resDays}</SummaryValue>
                </SummaryRow>
              </SummaryTable>
            </FormPanel>

            <FormButtonGroup>
              <SecondaryButton onClick={closeResModal}>{t('common.cancel')}</SecondaryButton>
              <PrimaryButton 
                onClick={submitReservation} 
                disabled={resSaving || !isFormValid}
                title={!isFormValid ? t('equipmentCalendar.fillRequired') : ''}
              >
                {resSaving ? t('common.saving') : t('equipmentCalendar.saveReservation')}
              </PrimaryButton>
            </FormButtonGroup>
          </FormContainer>

          {showEquipmentModal && (
            <InventoryModal
              isOpen={showEquipmentModal}
              onClose={() => setShowEquipmentModal(false)}
              equipmentList={availableEq}
              selectedIds={resSelectedEq}
              onToggle={handleEquipmentToggle}
            />
          )}

          <DatepickerTheme />
        </FormModal>
      )}
    </Container>
  );
}